import { DatePipe, KeyValuePipe, NgFor, NgIf } from '@angular/common';
import { Component, effect, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { AttachmentViewerComponent } from '@app/lib/components/attachment-viewer/attachment-viewer.component';
import { IAttachmentDialogData } from '@app/lib/models/dialog-data.model';
import { IResponse } from '@app/lib/models/response.model';
import { ICaseDocComment, ICaseDocument,ITrialPanelJudgesRequest, ICaseDocumentData, ICaseDocumentRequestBody, ICaseSearchRequestBody, IJudge, IMotionCaseNumber, IMotionCasenumberParams, ISearchRequestParams } from '../models/case-assignment.model';
import { CaseDocumentService } from '../services/case-document.service';

@Component({
  selector: 'app-case-documents',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    KeyValuePipe,
    DatePipe,
    FormsModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
  ],
  templateUrl: './case-documents.component.html',
  styleUrl: './case-documents.component.scss'
})
export class CaseDocumentsComponent {

  public caseNumber: InputSignal<string> = input.required({});
  public isSupreme = input<boolean>(false);

  public comments: WritableSignal<ICaseDocComment[]> = signal([]);
  public motionCaseDocs: WritableSignal<ICaseDocumentData | null> = signal(null);
  // public judgePanel: WritableSignal<IJudge[]> = signal([]);
  public tblCols: Record<string, string> = {
    docId: 'No',
    docName: 'Document Name'
  };
  public displayedColumns: string[] = Object.keys(this.tblCols);

  public motionCases: WritableSignal<IMotionCaseNumber[]> = signal([]);

  public selectedCase: WritableSignal<IMotionCaseNumber | null> = signal(null)

  constructor(private dialog: MatDialog, private service: CaseDocumentService) {
    effect(() => {
      if (this.caseNumber()) {
        this.getMotionDocs(this.caseNumber());
        // this.getTrialPanelJudges(this.caseNumber());
      } else {
        this.motionCases.set([]);
        this.motionCaseDocs.set(null);
        this.comments.set([]);
        this.selectedCase.set(null);
        // this.judgePanel.set([]);
      }
    }, { allowSignalWrites: true });
  }

  public openAttachmentDialog(document: ICaseDocument) {
    const data: IAttachmentDialogData = {
      path: 'documents/download.htm',
      queryParams: { fileRef: document.docURL }
    };

    this.dialog.open(AttachmentViewerComponent, {
      panelClass: 'dialog-pdf-viewer',
       disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
      data
    });
  }

  public caseChangeHandler(e: MatSelectChange) {
    const caseNo: IMotionCaseNumber | undefined = this.motionCases().find(item => item.id === (e.value as string));
    if (caseNo) {
      this.selectedCase.set(caseNo);
      this.getMotionDocsByCaseId(caseNo.id);
    }
  }

  private getMotionDocs(caseNumber: string) {
    const params: IMotionCasenumberParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'id',
      direction: 'ASC',
      caseNumber
    }
    this.service.getMotionCaseNumbers(params).subscribe({
      next: (res: { success: IMotionCaseNumber[] }) => {
        if (res?.success?.length) {
          this.motionCases.set(res.success.length ? res.success : []);
          if (this.motionCases().length) {
            this.selectedCase.set(res.success[0]);
            this.getMotionDocsByCaseId((this.selectedCase() as IMotionCaseNumber).id);
          } else {
            this.selectedCase.set(null);
            this.motionCaseDocs.set(null);
            this.comments.set([]);
          }
        }
      }
    })
  }

  private getMotionDocsByCaseId(caseId: string) {
    const reqBody: ICaseDocumentRequestBody = {
      caseNumber: caseId,
      docStatus: 'VALID'
    };
    const params: ISearchRequestParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'docId',
      direction: 'ASC'
    }
    this.service.getCaseFilesByMotionCase(reqBody, params).subscribe({
      next: (res: IResponse<ICaseDocument[]>) => {
        if (res?.data?.length) {
          const docs: ICaseDocumentData = {};
          res.data.forEach(item => {
            if (!docs[item.docTypeName]) {
              docs[item.docTypeName] = [];
            }
            docs[item.docTypeName].push(item);
          });
          this.motionCaseDocs.set(docs);
        } else {
          this.motionCaseDocs.set(null);
          this.comments.set([]);
        }
      }
    });
    const creqBody: ICaseSearchRequestBody = {
      caseNumber: caseId,
      dateOfFiling: 'null'
    }
    this.service.getCaseComments(creqBody, { ...params, property: 'caseNumber' }).subscribe({
      next: (res: IResponse<ICaseDocComment[]>) => {
        this.comments.set(res.data.length ? res.data.map(item => {
          item.dateOfFiling = new Date().getTime() + '';
          return item;
        }) : []);
      }
    })
  }

//   private getTrialPanelJudges(caseNumber: string) {
//  const reqBody: ITrialPanelJudgesRequest = {
//     id: 1,
//     panelSessionId: 1, 
//     hearingDate: new Date().toISOString()
//   };

//   const params: ISearchRequestParams = {
//     page: 1,
//     start: 0,
//     limit: 25,
//     property: 'justiceName',
//     direction: 'ASC'
//   };

//   this.service.getTrialPanelJudges(reqBody, params).subscribe({
//     next: (res: IResponse<IJudge[]>) => {
//       this.judgePanel.set(res.data || []);
//     }
//   });
// }

}
